/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignRequestDocument
 */
export interface SignRequestDocument {
    /**
     * The unique identifier of the document. Must reference an existing document ID within the signing request
     * @type {string}
     * @memberof SignRequestDocument
     */
    documentId?: string;
    /**
     * The globally unique identifier (GUID) of the document
     * @type {string}
     * @memberof SignRequestDocument
     */
    documentIdGuid?: string;
    /**
     * The file name of the document
     * @type {string}
     * @memberof SignRequestDocument
     */
    name?: string;
    /**
     * Specifies the sorting order of the document in the signing request (e.g., “asc” or “desc”)
     * @type {string}
     * @memberof SignRequestDocument
     */
    order?: string;
    /**
     * The size of the document, in bytes
     * @type {string}
     * @memberof SignRequestDocument
     */
    sizeBytes?: string;
    /**
     * The URI endpoint associated with the user ID
     * @type {string}
     * @memberof SignRequestDocument
     */
    uri?: string;
}

/**
 * Check if a given object implements the SignRequestDocument interface.
 */
export function instanceOfSignRequestDocument(value: object): boolean {
    return true;
}

export function SignRequestDocumentFromJSON(json: any): SignRequestDocument {
    return SignRequestDocumentFromJSONTyped(json, false);
}

export function SignRequestDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignRequestDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'documentId': json['documentId'] == null ? undefined : json['documentId'],
        'documentIdGuid': json['documentIdGuid'] == null ? undefined : json['documentIdGuid'],
        'name': json['name'] == null ? undefined : json['name'],
        'order': json['order'] == null ? undefined : json['order'],
        'sizeBytes': json['sizeBytes'] == null ? undefined : json['sizeBytes'],
        'uri': json['uri'] == null ? undefined : json['uri'],
    };
}

export function SignRequestDocumentToJSON(value?: SignRequestDocument | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'documentId': value['documentId'],
        'documentIdGuid': value['documentIdGuid'],
        'name': value['name'],
        'order': value['order'],
        'sizeBytes': value['sizeBytes'],
        'uri': value['uri'],
    };
}

